"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.__ = exports.PatternType = void 0;
var PatternType;

(function (PatternType) {
  PatternType["String"] = "@ts-pattern/string";
  PatternType["Number"] = "@ts-pattern/number";
  PatternType["Boolean"] = "@ts-pattern/boolean";
  PatternType["Guard"] = "@ts-pattern/guard";
  PatternType["Not"] = "@ts-pattern/not";
  PatternType["NamedSelect"] = "@ts-pattern/named-select";
  PatternType["AnonymousSelect"] = "@ts-pattern/anonymous-select";
})(PatternType = exports.PatternType || (exports.PatternType = {}));
/**
 * ### Catch All wildcard
 * `__` is wildcard pattern, matching **any value**.
 *
 * `__.string` is wildcard pattern matching any **string**.
 *
 * `__.number` is wildcard pattern matching any **number**.
 *
 * `__.boolean` is wildcard pattern matching any **boolean**.
 * @example
 *  match(value)
 *   .with(__, () => 'will always match')
 *   .with(__.string, () => 'will match on strings only')
 *   .with(__.number, () => 'will match on numbers only')
 *   .with(__.boolean, () => 'will match on booleans only')
 */


exports.__ = {
  string: PatternType.String,
  number: PatternType.Number,
  boolean: PatternType.Boolean
};